import React, { useState, Fragment } from 'react';
import { Drawer } from 'antd';
import { NavLink } from 'react-router-dom';
import { PAGES, usePermissions } from 'hooks/permissions/permissions';

/**
 * Configuration sub-navigation.
 *
 * Links are declared once and rendered into both the desktop bar and the mobile
 * drawer. They used to be written out twice with different wording, so the same
 * route was called "Company" on desktop and "Department" on mobile, and
 * "Employee Code" versus "RFID Tag" -- three of the five disagreed.
 *
 * `page` is the permission (by name, see hooks/permissions) whose VIEW gates the link.
 */
export const CONFIG_LINKS = [
    { to: '/configuration/employee', label: 'Employees', page: PAGES.EMPLOYEE },
    { to: '/configuration/department', label: 'Contractors', page: PAGES.CONTRACTOR },
    { to: '/configuration/shift', label: 'Shifts', page: PAGES.SHIFT },
    { to: '/configuration/rfid', label: 'RFID Readers', page: PAGES.RFID_READER },
    { to: '/configuration/zone', label: 'Sites', page: PAGES.SITE },
    { to: '/configuration/tag', label: 'RFID Cards', page: PAGES.RFID_CARD },
];

const ConfigHeader = () => {
    const [open, setOpen] = useState(false);

    const showDrawer = () => setOpen(true);
    const onClose = () => setOpen(false);

    const { can } = usePermissions();

    const visibleLinks = CONFIG_LINKS.filter((link) => can(link.page));

    return (
        <Fragment>
            <header className="jr-view-header view-header">
                <div className="web-links">
                    {visibleLinks.map((link) => (
                        <NavLink key={link.to} to={link.to}>{link.label}</NavLink>
                    ))}
                </div>
                <div className="mobile-view-only">
                    <h1 onClick={showDrawer}>Menu</h1>
                    <Drawer className='dra' placement="right" onClose={onClose} open={open}>
                        <ul>
                            {visibleLinks.map((link) => (
                                <li key={link.to}>
                                    <NavLink onClick={onClose} to={link.to}>{link.label}</NavLink>
                                </li>
                            ))}
                        </ul>
                    </Drawer>
                </div>
            </header>
        </Fragment>
    );
};

export default ConfigHeader;
